import { resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ReturnToHome = _resolveComponent("ReturnToHome")!
  const _component_GitHub = _resolveComponent("GitHub")!
  const _component_Sphere = _resolveComponent("Sphere")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ReturnToHome, { theme: "light" }),
    _createVNode(_component_GitHub, {
      theme: "light",
      url: "https://github.com/ts5h/sphere"
    }),
    _createVNode(_component_Sphere)
  ], 64))
}